import React from 'react';
import { IconButton } from '..';
import ReactTooltip from 'react-tooltip';

export function SubGroupItem({ group, isSelected, onSelect }) {
  const handleClick = (ev) => {
    ev.preventDefault();
    if (onSelect) onSelect(group);
  };

  let classNames = ['chronos-subgroup-picker-item'];
  if (isSelected) {
    classNames.push('chronos-subgroup-picker-item-active');
  }

  return (
    <div className={classNames.join(' ')}>
      {group.title}
      {isSelected && (
        <IconButton
          iconOnly
          icon="far fa-times fa-fw"
          data-tip="Remove Access"
          data-for="chronosSubGroupComponentTooltip"
          onClick={handleClick}
        />
      )}
      {!isSelected && (
        <IconButton
          iconOnly
          icon="far fa-plus fa-fw"
          color="green"
          className="chronos-btn-success"
          data-tip="Allow Access"
          data-for="chronosSubGroupComponentTooltip"
          onClick={handleClick}
        />
      )}
    </div>
  );
}
